import lazyLoadView from '@router-utils/lazyload-view'
import routeError from '@router-utils/route-error'
import { redirectIfHotelDisabled } from '@router-utils/require-hotel-enabled'

const hotelBeforeResolve =
  () =>
  async (routeTo, routeFrom, next) => {
    try {
      const redirected = await redirectIfHotelDisabled(next)
      if (redirected) return
      next()
    } catch (error) {
      routeError(error, routeTo, next({ name: '404' }), next)
    }
  }

export default [
  {
    path: '/hotel',
    name: 'hotel-search',
    component: () => lazyLoadView(import('@views/Hotel/Search')),
    meta: {
      title: '住宿搜尋',
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfHotelDisabled(next)
          if (redirected) return
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next)
        }
      },
    },
  },
  {
    path: '/hotel/price',
    name: 'hotel-price',
    component: () => lazyLoadView(import('@views/Hotel/Price')),
    meta: {
      title: '住宿價目',
      beforeResolve: hotelBeforeResolve(),
    },
  },
  /** 可選：`/hotel/order/flow#step2` 會導向 `/hotel/order/flow/2`（query 保留） */
  {
    path: '/hotel/order/flow',
    redirect: (to) => {
      const raw = (to.hash || '').replace(/^#/, '')
      const m = raw.match(/^step(\d+)$/i)
      let step = m ? parseInt(m[1], 10) : 1
      if (step < 1 || step > 4) step = 1
      return { path: `/hotel/order/flow/${step}`, query: to.query, hash: '' }
    },
  },
  /** 預約主流程：數字與步驟一致 — 1 選寵物、2 入住資訊、3 確認明細、4 確認付款 */
  {
    path: '/hotel/order/flow/1',
    name: 'hotel-order-flow-1',
    component: () => lazyLoadView(import('@views/Hotel/Order/SelectPet')),
    meta: {
      title: '住宿預約',
      beforeResolve: hotelBeforeResolve(),
    },
  },
  {
    path: '/hotel/order/flow/2',
    name: 'hotel-order-flow-2',
    component: () => lazyLoadView(import('@views/Hotel/Order/PetInfo')),
    meta: {
      title: '入住資訊',
      beforeResolve: hotelBeforeResolve(),
    },
  },
  {
    path: '/hotel/order/flow/3',
    name: 'hotel-order-flow-3',
    component: () => lazyLoadView(import('@views/Hotel/Order/CheckDetail')),
    meta: {
      title: '確認明細',
      beforeResolve: hotelBeforeResolve(),
    },
  },
  {
    path: '/hotel/order/flow/4',
    name: 'hotel-order-flow-4',
    component: () => lazyLoadView(import('@views/Hotel/Order/Payment')),
    meta: {
      title: '確認付款',
      beforeResolve: hotelBeforeResolve(),
    },
  },
  /** 舊網址相容（含書籤／外部連結） */
  {
    path: '/hotel/order/step1',
    redirect: (to) => ({ path: '/hotel/order/flow/1', query: to.query, hash: to.hash }),
  },
  {
    path: '/hotel/order/checkin',
    redirect: (to) => ({ path: '/hotel/order/flow/2', query: to.query, hash: to.hash }),
  },
  {
    path: '/hotel/order/step2',
    redirect: (to) => ({ path: '/hotel/order/flow/3', query: to.query, hash: to.hash }),
  },
  {
    path: '/hotel/order/step3',
    redirect: (to) => ({ path: '/hotel/order/flow/4', query: to.query, hash: to.hash }),
  },
  {
    path: '/hotel/order/hold-expired',
    name: 'hotel-order-hold-expired',
    component: () => lazyLoadView(import('@views/Hotel/Order/HoldExpired')),
    meta: {
      title: '住宿提示',
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfHotelDisabled(next)
          if (redirected) return
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next)
        }
      },
    },
  },
  {
    path: '/hotel/order/pending-evaluation',
    name: 'hotel-order-pending-evaluation',
    component: () => lazyLoadView(import('@views/Hotel/Order/PendingEvaluation')),
    meta: {
      title: '待店家確認',
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const redirected = await redirectIfHotelDisabled(next)
          if (redirected) return
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next)
        }
      },
    },
  },
]
